/** How many mark gradients the stylesheet has (`.hue0` … `.hue5`). */
export const CONSENT_MARK_HUES = 6;

/** A stable gradient index for an app name, so the same app has the same mark each time. */
export function consentMarkHue(name: string): number {
  let sum = 0;
  for (const char of name) {
    sum += char.codePointAt(0) ?? 0;
  }
  return sum % CONSENT_MARK_HUES;
}
